import { useEffect, useState } from "react";
import { Card, Section } from "../../../components";
import { SignificantTokenTransfers } from "../../../components/SignificantTokenTransfers/SignificantTokenTransfers";
import { BACKEND_AI_AGENT_URL } from "../../../config";
import { GatewayScore, Price, ProjectConfig, Volume } from "../types";
import "./AllTokens.scss";
import { AllTokensTable } from "./AllTokensTable/AllTokensTable";
import { EyeForDates } from "./components/EyeForDates/EyeForDates";
import { Trending } from "./components/Trending";
import { Dominance } from "./Dominance";
import MarketSentiment from "./MarketSentiment/MarketSentiment";
import { TrendingCards } from "./TrendingCards";
export interface AllProjects {
  project: ProjectConfig;
  volume: Volume;
  price: Price;
  gatewayScore: GatewayScore;
}
export interface TrendingProjects {
  project: ProjectConfig;
  gatewayScore: GatewayScore;
  price: Price;
}

export const AllTokens = () => {
  // fetch data
  const [allProjects, setAllProjects] = useState<AllProjects[]>([]);
  const [trendingProjects, setTrendingProjects] = useState<TrendingProjects[]>(
    [],
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTrendingData = async () => {
      try {
        const response = await fetch(
          `${BACKEND_AI_AGENT_URL}/homepage-projects`,
        );
        const data: {
          allProjects: AllProjects[];
          trendingProjects: TrendingProjects[];
        } = await response.json();

        setAllProjects(data.allProjects);
        setTrendingProjects(data.trendingProjects);
      } catch (error) {
        console.error("Failed to fetch trending narratives:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTrendingData();
  }, []);

  return (
    <>
      <Section size="xl">
        <div className="flex flex-col gap-4">
          <div className="flex flex-col md:flex-row flex-wrap lg:flex-nowrap gap-4 w-full">
            <div className="flex basis-1/2-gap-4 lg:basis-1/3-gap-4 w-full md:w-1/2 lg:w-1/3 order-1">
              <Card boldWatermark>
                <Trending projects={trendingProjects} isLoading={isLoading} />
              </Card>
            </div>
            <div className="flex basis-full flex-col gap-4 lg:basis-1/3-gap-4 order-2 md:order-3 lg:order-2">
              <Card className="flex flex-col gap-4" boldWatermark>
                <div className="flex justify-between">
                  <div className="font-bold">Trending narrations</div>
                </div>
                <TrendingCards />
              </Card>
              <div className="flex gap-4 flex-col md:flex-row ">
                <Card
                  boldWatermark
                  className="flex items-center justify-center min-w-[150px]"
                >
                  <div className="flex flex-col justify-between font-bold gap-3">
                    <div>Market sentiment</div>
                    <MarketSentiment />
                  </div>
                </Card>
                <Card className="flex flex-col gap-0" disableWatermark>
                  <Dominance />
                </Card>
              </div>
            </div>
            <div className="flex basis-1/2-gap-4 lg:basis-1/3-gap-4 w-full md:w-1/2 lg:w-1/3 order-3 md:order-2 lg:order-3">
              <Card boldWatermark>
                <SignificantTokenTransfers />
              </Card>
            </div>
          </div>
          <div className="max-w-full">
            <EyeForDates />
          </div>
          <div className="max-w-full">
            <AllTokensTable allProjects={allProjects} isLoading={isLoading} />
          </div>
        </div>
      </Section>
    </>
  );
};
